module.exports = __webpack_public_path__ + "static/img/trainingDuration.9b6f2e6d.svg";